import "./modal.scss";
import { FC, ReactNode, useEffect } from "react";
import { bemCN } from "../../config/bem-classname";

type ModalProps = {
  id: string;
  children: ReactNode;
  isShowDialog: boolean;
  setIsShowDialog(isShow: boolean): void;
};

const modalCN = bemCN("modal");

export const Modal: FC<ModalProps> = ({
  id,
  children,
  setIsShowDialog,
  isShowDialog,
}) => {
  let dialog: HTMLDialogElement | any;

  useEffect(() => {
    dialog &&
      dialog.addEventListener("close", (e: any) => {
        setIsShowDialog(false);
      });
  }, [dialog]);

  useEffect(() => {
    dialog = document.getElementById(id);

    if (dialog) {
      if (isShowDialog) {
        dialog.showModal();
      } else {
         dialog.close();
      }
    }
  }, [isShowDialog]);

  return (
    <dialog id={id} className={modalCN()}>
      {children}
    </dialog>
  );
};
